import React, { FC } from 'react'

import { IconParentalControlProps } from './IconParentalControl.types'
import * as Styled from './styles/IconParentalControl.style'

import { nonThemeableRules } from '../../ruleSet'

const IconParentalControl: FC<IconParentalControlProps> = ({
  size = nonThemeableRules.defaultSize as number as IconParentalControlProps['size'],
  isResponsive = false,
}: IconParentalControlProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M43.02 10.062c0 24.118-15.54 31.56-18.54 32.888a1.195 1.195 0 0 1-.98 0c-3-1.328-18.53-8.77-18.53-32.888 0-3.555 6.792 2.25 18.155-4.865a1.65 1.65 0 0 1 1.75 0C29.33 7.985 33.085 9.25 36 9.305h7.02v.757Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeWidth='2'
        />
        <path
          d='M15.617 29c1.08-4.165 3.778-6.655 7.053-6.655a6.124 6.124 0 0 1 3.18.88l.05.03'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M32.663 32.938c-.573-3.316-2.468-5.02-4.58-5.02-2.113 0-4.063 1.704-4.638 5.02'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M22.59 13h4.75v4.75a4.588 4.588 0 0 1-4.59 4.582h-.157A4.587 4.587 0 0 1 18 17.75v-.157A4.587 4.587 0 0 1 22.59 13Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M28.055 22.25h2.835v2.835a2.835 2.835 0 1 1-2.835-2.835Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconParentalControl
